import * as React from 'react';
import {Price} from '../Price/Price';
import {Subtitle} from '../ui/Subtitle/Subtitle';
import styles from './GetSubtitle.scss';
import {IInner} from './GetSubtitle.types';

export const GetSubtitleComponent: React.FunctionComponent<IInner> = ({price, currency, entityType}) => {
  const entityTranslationKeys = {
    album: 'mgw.downloadAlbumFor',
    single: 'mgw.downloadSingleFor',
    track: 'mgw.downloadTrackFor',
  };
  return (
    <>
      <Subtitle className={styles.subtitle} dataHook="subtitle-header">
        <Price price={price} currency={currency} translationKey="mgw.downloadPrice" />
      </Subtitle>
      <Subtitle className={styles.subtitleMobile} dataHook="subtitle-mobile-header">
        <Price price={price} currency={currency} translationKey={entityTranslationKeys[entityType]} />
      </Subtitle>
    </>
  );
};

GetSubtitleComponent.displayName = 'GetSubtitle';
